import React from "react";
import { Form, Input, Button, message } from "antd";

export default () => {
  const [form] = Form.useForm();

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background:
          "url(http://shopimg.jetour.com.cn/2025newweb/vehicles/shanhait14wd/home/sykvpc.jpg)",
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 100%",
      }}
    >
      <Form
        labelCol={{ span: 4 }}
        wrapperCol={{ span: 20 }}
        form={form}
        name="login"
        style={{ width: 500 }}
        colon={false}
      >
        <Form.Item
          label={<span style={{ color: "#fff" }}>用户名</span>}
          name="userName"
          rules={[{ required: true, message: "请输入用户名!" }]}
        >
          <Input placeholder="请输入用户名" />
        </Form.Item>
        <Form.Item
          label={<span style={{ color: "#fff" }}>密码</span>}
          name="password"
          rules={[{ required: true, message: "请输入密码！" }]}
        >
          <Input.Password placeholder="请输入密码" />
        </Form.Item>
        <Form.Item style={{ textAlign: "center" }} label={<></>}>
          <Button
            type="primary"
            style={{ background: "#e85519" }}
            onClick={() => {
              form.validateFields();
              const res = form.getFieldsValue(["userName", "password"]);
              if (!res?.userName || !res?.password) {
                return;
              }
              if (res?.userName !== "admin" || res?.password !== "admin123") {
                message.success("用户名或密码错误！");
                return;
              }
              message.success("登录成功！");
              window.location.href = "/homePage";
            }}
          >
            登录
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
